export default __webpack_public_path__ + "static/media/san-rafael-13.8934222a.jpg";